import React from 'react';
import { Services } from '../components/Services';
export function Servicios() {
  return <div className="pt-24" data-id="element-433">
      <Services data-id="element-434" />
    </div>;
}